<template>
    <Warehouse></Warehouse>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Warehouse = defineAsyncComponent(() =>
    import("../../components/Logistics/Warehouse/Warehouse.vue")
);

export default {
    components: { Warehouse, AuthLayout },
};
</script>
